import { render, staticRenderFns } from "./AppBanners.vue?vue&type=template&id=81f48044&scoped=true&"
import script from "./AppBanners.vue?vue&type=script&lang=js&"
export * from "./AppBanners.vue?vue&type=script&lang=js&"
import style0 from "./AppBanners.vue?vue&type=style&index=0&id=81f48044&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81f48044",
  null
  
)

export default component.exports